import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-people-520260363689.europe-west3.run.app';

/** Under /api/lever, so the proxy's candidate-comms guard covers it (routes/talent-community.js). */
const BASE = `${PROXY_URL}/api/lever/talent-community`;

/** One Vetted Talent row in Talent Search. No email: search does not need it. */
export interface VettedPerson {
  id: string;
  name: string;
  role: string | null;
  stage: string | null;
  location: string | null;
  archivedAt: string;
  consentUntil: string;
  /** Said yes to news (Scope B). Without it, only 1:1 job matches. */
  news: boolean;
  /** In a Lever hiring process right now: held back from campaigns. */
  inProcess: boolean;
  leverUrl: string | null;
  hasCv: boolean;
  /** Recent positions from the CV, "Title · Company". */
  cvLines: string[];
}

export interface ImportResult {
  dryRun: boolean;
  counts: Record<string, number>;
  lastError?: string;
}

async function json<T>(res: Response): Promise<T> {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.error || `Request failed (${res.status})`);
  return body as T;
}

export const VETTED_QUERY = {
  queryKey: ['talent-community', 'vetted'],
  queryFn: async (): Promise<VettedPerson[]> =>
    (await json<{ people: VettedPerson[] }>(await authenticatedFetch(`${BASE}/vetted`))).people,
  staleTime: 60_000,
} as const;

export async function runVettedImport(dryRun: boolean): Promise<ImportResult> {
  return json<ImportResult>(
    await authenticatedFetch(`${BASE}/vetted/import`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dryRun }),
    })
  );
}
